// Cellery Soapbox — brand wordmark (navy on white).
// Approved asset only; never stretched, recolored, or shadowed. Sizing is
// governed by .wordmark in theme.css (min-width 120px, fixed height, auto width).

export function Wordmark({ className }: { className?: string }) {
  return (
    <img
      src="/brand/Cellery_wordmark_navy.png"
      alt="Cellery Soapbox"
      className={className ? `wordmark ${className}` : "wordmark"}
      draggable={false}
    />
  );
}
